import type { RouteRecordRaw } from "vue-router";

export const routes = [
  {
    path: "/enroll-reject-config",
    name: "Enroll Reject Config",
    component: () => import("./rejectConfigPage.vue"),
  },
  {
    path: "/tickets/:ticketParam?",
    name: "Ticket Manager",
    component: () => import("./ticketManager.vue"),
  },
] satisfies RouteRecordRaw[];
